import {Component, OnInit} from '@angular/core';
import {EnvService} from "../../services/env.service";
import {HttpClient} from "@angular/common/http";
import {ActivatedRoute, Router, Params} from '@angular/router';
import {AlertService} from "../../services/alert.service";
import {AuthService} from "../../services/auth.service";

@Component({
  selector: 'micro-whatsappOutgoingMsgLog-detail',
  templateUrl: './whatsappOutgoingMsgLog-detail.component.html'
})
export class WhatsappOutgoingMsgLogDetailComponent implements OnInit {
  outMsgLog:any;
  contentMsg:any;

  constructor(private env: EnvService,
              private http: HttpClient,
              private route: ActivatedRoute,
              private router:Router,
              public authService:AuthService,
              private alertService:AlertService) {
  }

  public ngOnInit(): void {
    this.route.params
      .subscribe((params: Params) => {
        let id:number = params['id'];
        this.http.get(`${this.env.e.url}/chat/whatsapp/out/${id}`).subscribe(
          data => {
            this.setOutMsgLog(data);
            if (this.outMsgLog) {
              this.http.get(`${this.env.e.url}/chat/whatsapp/out/${id}/content`).subscribe(
                data => {
                  this.setContentMsg(data);
                }
              );
            }
          }
        );
      });
  }

  setOutMsgLog(outMsgLog:any) {
    this.outMsgLog = outMsgLog;
  }

  setContentMsg(contentMsg:any) {
    this.contentMsg = contentMsg;
  }

}
